export default "__VITE_ASSET__BX9470gA__"